export function uglyDispatch(action) {
    // silly hack to get at dispatch outside context of normal actions...
    // this opposes any number of redux/react 'best practices', but i'm
    // not sure of a better of being able to trigger global errors like
    // logouts, api status errors, etc. from here without massively tedious
    // passing around of actions via every request, etc.
    import('./store.js').then(({ default: store }) => {
        if (store && store.dispatch) {
            store.dispatch(action);
        }
    });
}
